import types from "../../types";

const initialState = {
  is_loading: false,
  successAlert: {},
  failureAlert: {},
};

const LoginReducer = (state = { initialState }, action) => {
  if (action.type === types.SEND_OTP_REQUEST) {
    return { ...state, is_loading: true };
  }
  if (action.type === "CHECK_STATUS") {
    return { ...state, checkStat: action.payload };
  }
  if (action.type === "QR_DATA") {
    return { ...state, qrData: action.payload };
  }
  if (action.type === "FORM_DATA") {
    return { ...state, formData: action.payload };
  }
  if (action.type === types.SEND_OTP_SUCCESS) {
    return { ...state, is_loading: false, otpSuccess: action.payload };
  }
  if (action.type === types.SEND_OTP_FAIL) {
    return { ...state, is_loading: false, otpFailure: action.payload };
  }

  if (action.type === types.LOGIN_REQUEST) {
    return { ...state, is_loading: true };
  }
  if (action.type === types.LOGIN_SUCCESS) {
    return { ...state, is_loading: false, loginSuccess: action.payload };
  }
  if (action.type === types.LOGIN_FAIL) {
    return { ...state, is_loading: false, loginFailure: action.payload };
  }

  if (action.type === types.RSM_REQUEST) {
    return { ...state, is_loading: true };
  }
  if (action.type === types.RSM_SUCCESS) {
    return { ...state, is_loading: false, rsmSuccess: action.payload };
  }
  if (action.type === types.RSM_FAIL) {
    return { ...state, is_loading: false, rsmFail: action.payload };
  }

  if (action.type === types.RSM_PHOTO_SUCCESS) {
    return { ...state, is_loading: false, rsmPhotoSuccess: action.payload };
  }
  if (action.type === types.RSM_PHOTO_FAIL) {
    return { ...state, is_loading: false, rsmPhotoFail: action.payload };
  }

  if (action.type === types.RSM_DEALER_ID_SUCCESS) {
    return { ...state, is_loading: false, rsmDealerIDSuccess: action.payload };
  }
  if (action.type === types.RSM_DEALER_ID_FAIL) {
    return { ...state, is_loading: false, rsmDealerIDFail: action.payload };
  }

  if (action.type === types.RSM_DEALER_PAN_SUCCESS) {
    return { ...state, is_loading: false, rsmDealerPANSuccess: action.payload };
  }
  if (action.type === types.RSM_DEALER_PAN_FAIL) {
    return { ...state, is_loading: false, rsmDealerPANFail: action.payload };
  }

  if (action.type === types.RSM_APPROVED) {
    return { ...state, is_loading: false, rsmApproved: action.payload };
  }
  if (action.type === types.RSM_APPROVED_FAIL) {
    return { ...state, is_loading: false, rsmApprovedFail: action.payload };
  }

  if (action.type === types.LOGOUT) {
    const obj = { ...action };
    delete obj.type;
    return { ...state, userLoginData: {}, ...obj };
  }
  return { ...state };
};

export default LoginReducer;
